// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/sass/app.scss
// module id = KqWi
// module chunks = 0